import { Modal } from "@mantine/core";
import { HeldEmailActionConfirmContent } from "./HeldEmailActionConfirmContent";
import { HeldEmailActionConfirmModel } from "./heldEmailActionConfirmModel";

export function HeldEmailActionConfirmModal({
  model,
}: {
  model: HeldEmailActionConfirmModel;
}) {
  return (
    <Modal
      centered
      closeOnClickOutside={false}
      onClose={model.onClose}
      opened={model.opened}
      title={model.title}
    >
      <HeldEmailActionConfirmContent model={model} />
    </Modal>
  );
}
